import React, { useEffect, useState } from 'react';
import './OrderAddressSelect.css';
import Header from '../common/Header';
import { Link, useNavigate } from 'react-router-dom';
import httpService from "../../services/HttpService";

const OrderAddressSelect = () => {
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        // Fetch addresses from the API using httpService
        const fetchAddresses = async () => {
            try {
                const response = await httpService.get('/address'); // Use httpService.get
                const data = await response.json(); // Parse the response as JSON
                setAddresses(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAddresses();
    }, []);

    const handleAddressSelect = async (addressId, cityId) => {
        const pendingOrderId = localStorage.getItem('pending_order_id');

        if (!pendingOrderId) {
            console.error('No pending order ID found in localStorage.');
            return;
        }
        try {
            const response = await httpService.put(`/orders/${pendingOrderId}`, {
                address_id: addressId,
            }); // Use httpService.put
            const data = await response.json(); // Parse the response as JSON
            localStorage.setItem('pending_order', JSON.stringify({cityId}))
            navigate('/order-time');
            
        } catch (error) {
            console.error('Error updating order with selected address:', error);
        }
    };

    // if (loading) return <p>Loading...</p>;
    if (loading) return <p></p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <Header />
            <main className="oa-page">
                <p className="oa-title">Адрес доставки</p>

                <Link to={`/order-address-add`} className="link">
                    <div className="oa-address-container">
                        <i className="material-symbols-sharp oa-address-icon">add_home_work</i>
                        <p className="oa-address-string">Новый адрес</p>
                    </div>
                </Link>

                {addresses.map((address) => (
                    <div
                        className="oa-address-container"
                        key={address.id}
                        onClick={() => handleAddressSelect(address.id, address.city_id)} // Handle address selection
                    >
                        <i className="material-symbols-sharp oa-address-icon">domain</i>
                        <p className="oa-address-string">
                            {address.city.name}, {address.street}, {address.house}
                        </p>
                    </div>
                ))}
            </main>
        </>
    );
};

export default OrderAddressSelect;